export class User {

    idUser: number;
    idFirebase:string;
    rgpd:boolean;

    public static fromJson(json: Object): User {
        return new User(
            json['idUser'],
            json['idFirebase'], 
            json['rgpd']
            )
    }

    constructor(pIdUser:number, idFirebase:string, rgpd:boolean){
        this.idUser=pIdUser;
        this.idFirebase=idFirebase;
        this.rgpd=rgpd;
    }

    public getIdUser():number{
        return this.idUser;
    }


    
}